import React from 'react'
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material"
import PatientCountCell from '../../../../components/patient-count-cell/PatientCountCell';

const UpakarmaReport = (props) => {
  return (
    <>
      <TableContainer classes={{ root: "fixed-head-table-container" }}  >
        <Typography variant="body1" className="report-heading">उपक्रम प्रतिवेदन</Typography>
        <Table classes={{ root: "table-bordered normal-spacing" }} size="small" aria-label="Ksharasutra-Sewa-Report">
          <TableHead classes={{ root: "align-center fixed-header header-sm" }}>
            <TableRow>
              <TableCell colSpan={2}> सेवाको विवरण</TableCell>
              <TableCell>स्थानिक बस्ति</TableCell>
              <TableCell>शिरोधारान</TableCell>
              <TableCell>पोटली स्वेद</TableCell>
              <TableCell>क्रियाकल्प</TableCell>
              <TableCell>पिचु</TableCell>
              <TableCell>प्रक्षालन</TableCell>
              <TableCell>अन्य</TableCell>
            </TableRow>
          </TableHead>
          <TableBody classes={{ root: "align-center" }}>
            <TableRow>
              <TableCell rowSpan={2}>सेवाग्राही संख्या </TableCell>
              <TableCell>महिला</TableCell>
              <PatientCountCell data={props?.tableData?.UPA_KARMA?.PATIENT_COUNT?.FEMALE?.[11]} />
              <PatientCountCell data={props?.tableData?.UPA_KARMA?.PATIENT_COUNT?.FEMALE?.[12]} />
              <PatientCountCell data={props?.tableData?.UPA_KARMA?.PATIENT_COUNT?.FEMALE?.[13]} />
              <PatientCountCell data={props?.tableData?.UPA_KARMA?.PATIENT_COUNT?.FEMALE?.[14]} />
              <PatientCountCell data={props?.tableData?.UPA_KARMA?.PATIENT_COUNT?.FEMALE?.[15]} />
              <PatientCountCell data={props?.tableData?.UPA_KARMA?.PATIENT_COUNT?.FEMALE?.[16]} />
              <PatientCountCell data={props?.tableData?.UPA_KARMA?.PATIENT_COUNT?.FEMALE?.[17]} />
            </TableRow>
            <TableRow>
              <TableCell>पुरुष</TableCell>
              <PatientCountCell data={props?.tableData?.UPA_KARMA?.PATIENT_COUNT?.MALE?.[11]} />
              <PatientCountCell data={props?.tableData?.UPA_KARMA?.PATIENT_COUNT?.MALE?.[12]} />
              <PatientCountCell data={props?.tableData?.UPA_KARMA?.PATIENT_COUNT?.MALE?.[13]} />
              <PatientCountCell data={props?.tableData?.UPA_KARMA?.PATIENT_COUNT?.MALE?.[14]} />
              <PatientCountCell data={props?.tableData?.UPA_KARMA?.PATIENT_COUNT?.MALE?.[15]} />
              <PatientCountCell data={props?.tableData?.UPA_KARMA?.PATIENT_COUNT?.MALE?.[16]} />
              <PatientCountCell data={props?.tableData?.UPA_KARMA?.PATIENT_COUNT?.MALE?.[17]} />
            </TableRow>
            <TableRow>
              <TableCell rowSpan={2}>सेवा संख्या </TableCell>
              <TableCell>महिला</TableCell>
              <PatientCountCell data={props?.tableData?.UPA_KARMA?.SERVICE_COUNT?.FEMALE?.[11]} />
              <PatientCountCell data={props?.tableData?.UPA_KARMA?.SERVICE_COUNT?.FEMALE?.[12]} />
              <PatientCountCell data={props?.tableData?.UPA_KARMA?.SERVICE_COUNT?.FEMALE?.[13]} />
              <PatientCountCell data={props?.tableData?.UPA_KARMA?.SERVICE_COUNT?.FEMALE?.[14]} />
              <PatientCountCell data={props?.tableData?.UPA_KARMA?.SERVICE_COUNT?.FEMALE?.[15]} />
              <PatientCountCell data={props?.tableData?.UPA_KARMA?.SERVICE_COUNT?.FEMALE?.[16]} />
              <PatientCountCell data={props?.tableData?.UPA_KARMA?.SERVICE_COUNT?.FEMALE?.[17]} />
            </TableRow>
            <TableRow>
              <TableCell>पुरुष</TableCell>
              <PatientCountCell data={props?.tableData?.UPA_KARMA?.SERVICE_COUNT?.MALE?.[11]} />
              <PatientCountCell data={props?.tableData?.UPA_KARMA?.SERVICE_COUNT?.MALE?.[12]} />
              <PatientCountCell data={props?.tableData?.UPA_KARMA?.SERVICE_COUNT?.MALE?.[13]} />
              <PatientCountCell data={props?.tableData?.UPA_KARMA?.SERVICE_COUNT?.MALE?.[14]} />
              <PatientCountCell data={props?.tableData?.UPA_KARMA?.SERVICE_COUNT?.MALE?.[15]} />
              <PatientCountCell data={props?.tableData?.UPA_KARMA?.SERVICE_COUNT?.MALE?.[16]} />
              <PatientCountCell data={props?.tableData?.UPA_KARMA?.SERVICE_COUNT?.MALE?.[17]} />
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </>
  )
}

export default UpakarmaReport;
